import { Provider } from 'react-redux'
import { Route } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'
import moment from 'moment-timezone'

import App from 'app/components/App'
import 'app/common/fonts/fonts.module.scss'
import 'app/common/fonts/fonts'

import store from './store'
import history from './history'
import './styles/index.scss'

// Русский момент во всем проекте
moment.locale('ru')

const Application = () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Route component={App} />
      </ConnectedRouter>
    </Provider>
  )
}

export default Application
